// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareFlyOutStyles } from "@awc/Overrides/Components/ProductCompareFlyOut";
import IconInputCheck from "@awc/XDL/Icons/IconInputCheck";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

const drawerContainerCss = css`
    width: 60%;
    max-width: 450px;
    ${xScreen("lte", "sm")} {
        max-width: unset;
        width: 320px;
        height: 137px;
    }
`;

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 143,
    cssOverrides: {
        scrim: css`
            margin: auto;
            ${drawerContainerCss}
        `,
        drawerBody: css`
            padding: 16px;
            background: ${color("common.white")};
            ${drawerContainerCss}
        `,
        drawerTitle: css`
            display: none;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.headerActionsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        gap: 6px;
        ${xScreen("lte", "sm")} {
            justify-content: center;
            flex-direction: row-reverse;
        }
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    css: css`
        margin: 0;
    `,
    variant: "secondary",
};

productCompareFlyOutStyles.headerCompareButton = {
    css: css`
        margin: 0;
    `,
    icon: {
        src: IconInputCheck,
        position: "left",
    },
};

productCompareFlyOutStyles.carousel = {
    carouselGridItem: {
        width: 12,
        css: css`
            &&& {
                margin-bottom: 16px;
                max-width: 100%;
                flex-basis: 100%;
            }
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    carouselSlide: {
        css: css`
            width: calc((100% - (5 * 18px)) / 6) !important;
        `,
    },
    carouselSlideInner: {
        css: css`
            padding: 0;
        `,
    },
    mainContainer: {
        gap: 0,
        offsetCss: css`
            justify-content: center;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            gap: 18px;
        `,
    },
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    variant: "link" as any,
    css: css`
        position: absolute;
        right: 0;
    `,
};

productCompareFlyOutStyles.headerTitleGridItem = {
    width: 12,
    css: css`
        display: none;
        ${xScreen("lte", "sm")} {
            display: flex;
            background: ${color("common.ui26")};
            padding: 8px;
            font-weight: bold;
            border: 2px solid transparent;
            &&& {
                margin-bottom: 8px;
            }
        }
    `,
};

productCompareFlyOutStyles.headerTitleText = {
    size: 16,
    lineHeight: "24px",
    css: css`
        margin-bottom: 0;
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButtonIcon = {
    size: 16,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        min-height: 70px;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};
